const CreateNewItem = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Items/AddItem`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    });

    if (response.ok) {
      return await response.json();
    } else if (response.status === 400) {
      const errorData = await response.json();
      console.error("Bad Request:", errorData);
      // Log the error data received from the server
      // If the server provides specific error messages, you can access them like this:
      if (errorData.errors) {
        // Log each validation error
        for (const key in errorData.errors) {
          if (errorData.errors.hasOwnProperty(key)) {
            console.error(`Validation Error (${key}): ${errorData.errors[key]}`);
          }
        }
      }
    }
  } catch (err) {
    console.log(err);
    return null;
  }
};

export default CreateNewItem;
